import { render, staticRenderFns } from "./FinanceTabCommissions.vue?vue&type=template&id=4a49552b&scoped=true"
import script from "./FinanceTabCommissions.vue?vue&type=script&lang=js"
export * from "./FinanceTabCommissions.vue?vue&type=script&lang=js"
import style0 from "./FinanceTabCommissions.vue?vue&type=style&index=0&id=4a49552b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a49552b",
  null
  
)

export default component.exports